<!--
 * @Author: Jairo Qu
 * @Date: 2021-08-02 10:00:37
 * @LastEditors: Jairo Qu
 * @LastEditTime: 2021-08-02 10:40:34
 * @Description: 页脚备案信息
 * @FilePath: /passengerh5-njs-web/client/projects/public/couponTemplate/src/components/footer.vue
-->
<template>
  <div class="footer">
    <p>北京畅行信息技术有限公司 京ICP备14055018号-4</p>
  </div>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<style lang="scss" scoped>
 .footer {
   font: 400 0.24rem/0.34rem PingFangSC, PingFangSC-Regular;
   color: #c5c5c5;
   padding: 0.48rem 0 0.96rem;

   p {
     text-align: center;
   }
 }
</style>
